import React, { useCallback, useState } from 'react';

import DownloadIcon from '@mui/icons-material/Download';
import { Button, Menu, MenuItem } from '@mui/material';
import { useFeatureFlag } from '@submodule/hooks/useFeatureFlag';

import { isPoliciesExportEnabled } from '../../const';

export type ExportMenuItem = {
  label: string;
  onClick: () => void;
};

type Props = {
  disabled?: boolean;
  loading?: boolean;
  menuItems: ExportMenuItem[];
};

const ExportButton = ({ disabled, loading, menuItems }: Props) => {
  const isExportEnabled = useFeatureFlag(isPoliciesExportEnabled, false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const isInIframe = window.self !== window.top;

  if (!isExportEnabled || isInIframe) {
    return null;
  }

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        disabled={disabled}
        loading={loading}
        onClick={handleOpen}
        endIcon={<DownloadIcon />}
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.label}
            onClick={() => {
              handleClose();
              setTimeout(item.onClick, 300);
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ExportButton;
